import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { seo } from "@/config/site";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = seo[pathname] || seo["/"];
    document.title = meta.title;
    setMeta("name", "description", meta.description);
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.description);
    setMeta("name", "twitter:title", meta.title);
    setMeta("name", "twitter:description", meta.description);
    const img = new URL(meta.image || "/assets/dhamma-logo-official-transparent.png", window.location.origin).href;
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:image", img);
  }, [pathname]);
}
